export const VIEW_DATE_FIELDS_SETTING_EXPERIENCE_NAME = 'viewDateFieldsSetting';

export const FETCH_AVAILABLE_DATE_FIELDS_ACTION_SUBJECT = 'fetchAvailableDateFields';
export const FETCH_AVAILABLE_DATE_FIELDS_METRICS_KEY = 'fetch-available-date-fields';

export const PAGE_ANALYTICS_SOURCE = 'date-fields-settings-page';
